import Vue from 'vue';
import Router from 'vue-router';

import App from './pages/App.vue';
import Plugin from './pages/Plugin.vue';
import Nesting from './components/Nesting.vue';

Vue.use(Router);

const base = process.env.BASE_ENV || '/';

export default new Router({
  base: base,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'App',
      component: App
    },
    {
      path: '/templates/:id',
      name: 'Templates',
      component: App
    },
    {
      path: '/brand/:id',
      name: 'Brand',
      component: App
    },
    {
      path: '/plugin',
      name: 'Plugin',
      component: Plugin
    },
    {
      path: '/preview',
      name: 'Preview',
      component: Plugin
    },
    {
      path: '/nesting',
      name: 'Nesting',
      component: Nesting
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.js